import { render, staticRenderFns } from "./TeacherSpeechRecognition.vue?vue&type=template&id=71b56b4d&scoped=true"
import script from "./TeacherSpeechRecognition.vue?vue&type=script&lang=ts"
export * from "./TeacherSpeechRecognition.vue?vue&type=script&lang=ts"
import style0 from "./TeacherSpeechRecognition.vue?vue&type=style&index=0&id=71b56b4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b56b4d",
  null
  
)

export default component.exports